import cn from "classnames";
import { FC } from "react";
import styled from "styled-components";
import { Fund } from "components/base/TableFunds/types";
import { getPercentageValue } from "lib/utils/table/getPercentageValue";

interface TableProps {
  fund: Fund | undefined;
  className?: string;
}

interface RowProps {
  label: string;
  value?: string | number;
}
export const Row = ({ label, value = undefined }: RowProps) => {
  const isNumber = typeof value === "number";

  const valueToRender = isNumber ? getPercentageValue(value * 100) : value;

  if (!value) return null;

  return (
    <div className="Table__Row  Table__Row__Styled">
      <div className="Table__cell">{label}</div>
      <div
        className={cn("Table__cell Font_16_22_600", {
          Table__cell__green: isNumber && value >= 0,
          Table__cell__red: isNumber && value < 0,
        })}
      >
        {valueToRender}
      </div>
    </div>
  );
};

export const Table: FC<TableProps> = ({ fund, className = "" }) => {
  return (
    <StyledTable className={cn("Font_16_22_450 Color_fog80", className)}>
      <Row label="Symbol" value={fund?.symbol} />
      <Row label="Category" value={fund?.fund_type} />
      <Row label="Share Price" value={fund?.price?.display_cents} />
      <Row label="Expense ratio" value={getPercentageValue((fund?.expense_ratio?.scalar ?? 0) * 100)} />
      <Row label="1yr Return" value={fund?.one_year_return?.scalar} />
      <Row label="5yr Return" value={fund?.five_year_return?.scalar} />
      <Row label="10yr Return" value={fund?.ten_year_return?.scalar} />
      <Row label="YTD" value={fund?.ytd_return?.scalar} />
    </StyledTable>
  );
};

const StyledTable = styled.div`
  .Table__Row {
    display: grid;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr; /* Define the width of subsequent columns */
    grid-auto-flow: column; /* Arrange items in columns */
    width: 100%;
    align-items: center;
    text-align: right;
  }

  .Table__cell {
    position: relative;
  }

  .Table__cell:first-child {
    text-align: left;
  }

  .Table__cell:empty::before {
    content: "";
    display: inline-block;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    width: 16px;
    height: 1px;
    background: ${({ theme }) => theme.colors.fog["80"]};
  }

  .Table__Row__Styled {
    border-top: 1px solid ${({ theme }) => theme.colors.fog["20"]};
    padding: 8px 0;
  }

  .Table__Row__Styled:first-child {
    border: 0;
  }

  .Table__cell__green {
    color: #00693d;
  }

  .Table__cell__red {
    color: #912525;
  }
`;
